import { withInstall } from "../utils/index.mjs";
import _Popover from "./Popover.mjs";
const Popover = withInstall(_Popover);
var stdin_default = Popover;
import { popoverProps } from "./Popover.mjs";
export {
  Popover,
  stdin_default as default,
  popoverProps
};
